<template>
  <div class="provider-login-button-wrap">
    <button
      class="login-element provider-button white-button lb-16 hover bg-important-bg border-important-border hover:bg-important-hover"
      @click="clickHandler"
    >
      <em
        v-if="logoName"
        class="custom-icons bg-transparent"
        :style="logoStyle"
      />
      <div
        v-if="buttonLabel"
        class="login-button-label text-text-default"
      >
        {{ buttonLabel }}
      </div>
    </button>
  </div>
</template>

<script>
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'ProviderLoginButton',
  props: {
    providerId: {
      type: String,
      required: false,
      default: '',
    },
    logoName: {
      type: String,
      required: false,
      default: '',
    },
    buttonLabel: {
      type: String,
      required: false,
      default: '',
    },
  },
  defineEmits: ['loginClick'],
  setup() {
    const { iconPath, getCustomIconStyle } = useCustomIcon();

    return {
      iconPath,
      getCustomIconStyle,
    };
  },
  computed: {
    logoStyle() {
      return this.getCustomIconStyle(this.iconPath(this.logoName), {}, false);
    },
  },

  methods: {
    clickHandler() {
      this.$emit('loginClick', this.providerId);
    },
  },
};
</script>
